/**
 * 瀑布流布局
 */
import Vue from 'vue'
import waterfall from 'vue-waterfall2'

Vue.use(waterfall)
